import React from 'react'
import { cardLayout } from '../../assets/images/focusCard'
import './style.css';
export default function TestMonialCard({name,name2,content,image,designation,company,left,top,x,y,r}) {
    

    return (
        <div style={{
            left,top,
            transform: `translate(${x}px,${y}px)`,
            rotate:`${r}deg`
        }} className='testCard-main'>
            <img src={`data:image/svg+xml;utf8,${encodeURIComponent(cardLayout("#2C2C2C"))}`} className='test-img-focusCard' />
            <div className='testCard-content-main'>
              <img src={image?require(`../../assets/images/${image}`):require("../../assets/images/testprofile.png")} className='test-card-dp-img' />
              <p className='testCard-name-text'>{name}</p>
              <p className='testCard-name2-text'>{name2}</p>
              <p className='testCard-comapny-text'>{designation}<br />{company}</p>
              <div style={{flex:1}} />
              <p className='testCard-content-text'>{content}</p>
            </div>
        </div>
    )
}
